import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const RightArrowIcon = React.forwardRef(
  (
    { className, bgColor, style, bgOpacity, removeSwiperClass, ...rest },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        className={classnames(
          {
            'swiper-button-next': !removeSwiperClass,
          },
          className,
        )}
        xmlns='http://www.w3.org/2000/svg'
        width='42'
        height='42'
        viewBox='0 0 42 42'
        style={style}>
        <g
          id='Group_341'
          data-name='Group 341'
          transform='translate(-1743 -1161)'>
          <circle
            id='Ellipse_17'
            data-name='Ellipse 17'
            cx='21'
            cy='21'
            r='21'
            transform='translate(1743 1161)'
            fill={bgColor || '#fff'}
            opacity={bgOpacity || '0.45'}
          />
          <line
            id='Left_Panel_Close_2'
            data-name='Left Panel Close 2'
            x1='12.764'
            y1='8.711'
            transform='translate(1759.729 1173.795)'
            fill='none'
            stroke='#fff'
            strokeLinecap='round'
            strokeWidth='1.5'
          />
          <line
            id='Left_Panel_Close_2-2'
            data-name='Left Panel Close 2'
            x1='12.764'
            y2='8.711'
            transform='translate(1759.729 1182.506)'
            fill='none'
            stroke='#fff'
            strokeLinecap='round'
            strokeWidth='1.5'
          />
        </g>
      </svg>
    )
  },
)

RightArrowIcon.propTypes = {
  removeSwiperClass: PropTypes.bool,
}

RightArrowIcon.defaultProps = {
  removeSwiperClass: false,
}

export default RightArrowIcon
